<template>
  <aside
    class="armory-showcase"
    :style="{ '--armory-accent': accent || 'var(--primary)' }"
    :aria-label="`${title} loadout summary`"
  >
    <div class="armory-showcase-stage" aria-hidden="true">
      <span class="armory-showcase-orbit"></span>
      <span class="armory-showcase-orbit is-inner"></span>
      <span class="armory-showcase-portrait">
        <img v-if="portrait || emblem" :src="portrait || emblem" alt="">
        <i v-else class="fa-solid fa-shield-halved"></i>
      </span>
      <span v-if="portrait && emblem && portrait !== emblem" class="armory-showcase-emblem">
        <img :src="emblem" alt="">
      </span>
    </div>

    <div class="armory-showcase-copy">
      <span>{{ eyebrow }}</span>
      <strong>{{ title }}</strong>
      <small v-if="subtitle">{{ subtitle }}</small>
      <div v-if="metrics.length" class="armory-showcase-metrics">
        <span v-for="metric in metrics" :key="metric.label">
          <small>{{ metric.label }}</small>
          <b>{{ metric.value }}</b>
        </span>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'GearLoadoutShowcase',
  props: {
    eyebrow: {
      type: String,
      default: 'Loadout',
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    emblem: {
      type: String,
      default: '',
    },
    portrait: {
      type: String,
      default: '',
    },
    accent: {
      type: String,
      default: '',
    },
    metrics: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
